import { render, staticRenderFns } from "./TableLocaisPatio.vue?vue&type=template&id=45c60476&scoped=true"
import script from "./TableLocaisPatio.vue?vue&type=script&lang=js"
export * from "./TableLocaisPatio.vue?vue&type=script&lang=js"
import style0 from "./TableLocaisPatio.vue?vue&type=style&index=0&id=45c60476&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c60476",
  null
  
)

export default component.exports